<template>
  <div>
    <v-row class="mb-5">
      <v-select
          :items="tags"
          item-text="name"
          item-value="handle"
          label="Tags"
          multiple
          auto-grow
          aria-required="true"
          color="primary"
          placeholder="Change Tags"
          :value="value"
          @input="onInput"
          flat
          solo
          clearable
          chips
          hint="What are the associated tags?"
          persistent-hint
          prepend-icon="mdi-tag"
      >
      </v-select>
    </v-row>

    <v-row v-if="validationError && validationError.fields && validationError.fields.tags">
      <p class="error--text">
        At least one tag should be selected.
      </p>
    </v-row>
  </div>

</template>

<script>
import {mapGetters} from "vuex";

/**
 * @example <TagsInput v-model="foo" validationError="bar"/>
 * @param {array} v-model the model that you want to store the tags in
 * @param {object} validationError The validation error model that gets returned from the API
 */

export default {
  name: "TagsInput",
  computed: {
    ...mapGetters([ 'tags' ]),
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    validationError: Object,
  },
  methods: {
    onInput (newValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>